import React, { createContext, useContext, useEffect, useState } from "react";
import { updateDemoMode } from "actions/user"
import AuthService from "tools/AuthService";

const AppContext = createContext();

export const ContextProvider = ({ children }) => {
  const [isDemoMode, setIsDemoMode] = useState(() => {
    const demoMode = localStorage.getItem("demoMode");
    return demoMode !== null ? demoMode === "true" : null;
  })

  const [hasClientPortal, setHasClientPortal] = useState(() => {
    const hasPortal = JSON.parse(localStorage.getItem("user"))?.hasClientPortal;
    return hasPortal !== null ? hasPortal : null;
  })
  const demoModeFeatureActive = AuthService.hasPrivilege("MANAGE_DEMO_MODE_FEATURE") && AuthService.getClientFeatures().demoModeEnabled;

  useEffect(() => {
    if (isDemoMode !== null && demoModeFeatureActive) {
      localStorage.setItem("demoMode", isDemoMode.toString());
    }
  }, [isDemoMode, demoModeFeatureActive]);

  const setDemoMode = (flag) => {
    if(!demoModeFeatureActive) return
    updateDemoMode(flag).then(() => setIsDemoMode(flag))
  }

  return (
    <AppContext.Provider value={{ isDemoMode, setDemoMode, demoModeFeatureActive,hasClientPortal, setHasClientPortal }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
